import { queryOptions } from '@tanstack/react-query';

import { EntryTypeFieldType } from 'chaika-enums';

import { CustomFieldApi } from '@api/CustomFieldApi';

export const customFieldKeys = {
    all: ['customField'] as const,
    list: () => [...customFieldKeys.all, 'list'] as const,
    byFieldType: (fieldType: EntryTypeFieldType) => [...customFieldKeys.all, fieldType] as const,
};

export const customFieldQueryOptions = {
    list: () =>
        queryOptions({
            queryKey: customFieldKeys.list(),
            queryFn: () => CustomFieldApi.getCustomFieldList(),
        }),
    byFieldType: (fieldType: EntryTypeFieldType) =>
        queryOptions({
            queryKey: customFieldKeys.byFieldType(fieldType),
            queryFn: () => CustomFieldApi.getField(fieldType),
        }),
};
